import React, { useState } from 'react'
import {FaBars, FaTimes, FaGithub, FaLinkedin} from "react-icons/fa";
// import {HiOutlineMail} from "react-icons/hi"; 
import {BsFillPersonLinesFill} from "react-icons/bs";
import logo from "../assets/logo.png";
import {Link} from "react-scroll";

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const handleClick = () => setNav(!nav);

  return (
    <div className='fixed z-10 w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300'>
        <div>
            <img src={logo} alt="Logo" style={{width:"120px "}} />
        </div>
        {/* {menu} */}
        <ul className='hidden md:flex'>
                <Link  to="home" smooth={true} duration={500}>
                <li>
                    Home
                </li>
                </Link>
                <Link  to="about" smooth={true} duration={500}>
                <li>
                    About
                </li>
                </Link>
                <Link  to="skills" smooth={true} duration={500}>
                <li>
                    Skills
                </li>
                </Link>
                <Link  to="work" smooth={true} duration={500}>
                <li>
                    Work
                </li>
                </Link>
                <Link  to="contact" smooth={true} duration={500}>
                <li>
                    Contact
                </li>
                </Link>
        </ul>

        {/* {hamburger} */}
        <div onClick={handleClick} className='md:hidden z-10 cursor-pointer'>
            {!nav? <FaBars /> : <FaTimes />}
        </div>

        {/* {mobile menu} */}
        <ul className={!nav ? "hidden" : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center' }>
            <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="home" smooth={true} duration={500}>
                    Home
                </Link>
            </li>
            <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="about" smooth={true} duration={500}>
                    About
                </Link>
            </li>
            <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="skills" smooth={true} duration={500}>
                    Skills
                </Link>
            </li>
            <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="work" smooth={true} duration={500}>
                    Work
                </Link>
            </li>
            <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="contact" smooth={true} duration={500}>
                    Contact
                </Link>
            </li>
        </ul>
        
        {/* {social icons} */}
        <div className='hidden fixed lg:flex flex-col top-[35%] left-0'>
            <ul>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600'>
                    <a href="https://www.linkedin.com/in/saransh-gautam/" className='flex justify-between items-center w-full text-gray-300' target="_blank">LinkedIn<FaLinkedin size={30} /></a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]'>
                    <a href="https://github.com/1mpactBot" className='flex justify-between items-center w-full text-gray-300' target="_blank">Github<FaGithub size={30} /></a>
                </li>
                {/* <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]'>
                    <a href="/#contact" className='flex justify-between items-center w-full text-gray-300'>Email<HiOutlineMail size={30} /></a>
                </li> */}
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69]'>
                    <a href="https://drive.google.com/file/d/1VuY5UoRqYIbeUpF8Fzebj449IDlzjw9P/view?usp=sharing" className='flex justify-between items-center w-full text-gray-300' target="_blank">Resumè<BsFillPersonLinesFill size={30} /></a>
                </li>
            </ul>
        </div>
    </div>
  ) 
}

export default Navbar
